import { useState } from "react";
import { useNavigate } from "react-router-dom";
import CommonBreadcrumb from "../../components/CommonBreadcrumb";
import SubadminList from "../../features/manageSubAdmin/subAdminList";
import SubadminListTopbar from "../../features/manageSubAdmin/topbar";

const ManageSubadmin = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");

  return (
    <>
      <CommonBreadcrumb
        title="Sub-Admins"
        breadcrumbItems={[
          { label: "Dashboard", onClick: () => navigate("/dashboard") },
          { label: "Sub-Admins" },
        ]}
      />
      
      <div className="cards">
        <SubadminListTopbar search={search} setSearch={setSearch} />
        <SubadminList search={search} />
      </div>
    </>
  );
};

export default ManageSubadmin;
